import { useEffect } from 'react';

/**
 * 選択肢が1件のみのとき、未選択ならその値を自動選択する。
 *
 * R / L 検討ツールの計算セット選択カスケード（proj→…→calculation）で各 Select に組み込み、
 * 「一意に定まる階層まで」自動で選択を降ろすために使う。各 Select が同一ルールを持つため、
 * 自動選択 → atom setter による下位リセット → 下位の再 fetch → また1件なら自動選択、と再帰的に連鎖する。
 *
 * 注意点:
 * - value が空のときだけ埋めるので、復帰時に既選択があれば保持する。
 * - set 後は value が非空になり再発火しない（ループしない）。
 * - items は「現在の親に対応する確定済み」のみを渡すこと（tree hook 側で stale を空にしている）。
 *   stale な単一候補を渡すと親切替直後に誤って自動選択してしまうため。
 */
export function useAutoSelectSingle(
    items: string[],
    loading: boolean,
    value: string,
    setValue: (next: string) => void,
): void {
    useEffect(() => {
        if (!loading && value === '' && items.length === 1) {
            setValue(items[0]);
        }
    }, [loading, value, items, setValue]);
}
